import http from '@/axios/http'

// Regulamentos da tela /Regras. Os PDFs enviados pela interface ficam no banco;
// quem não tem versão enviada cai no arquivo estático do build.
export const list = () =>
  http
    .get('/get_rule_documents')
    .then(response => response.data)

// upload: { slug, name, pdf (base64 sem prefixo data:), pages }
export const upload = (doc) => {
  const headers = { 'Content-Type': 'application/json' }
  if (localStorage.getItem('token')) {
    headers.Auth = localStorage.getItem('token')
  }
  return http
    .post('/set_rule_document', { ...doc }, { headers })
    .then(response => response.data)
}
